import React from 'react';
import axios from "axios";
import Select, { components } from "react-select";
import { useState, useEffect, useMemo, useRef} from 'react';
import MaterialReactTable from 'material-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPencil, faTrashAlt, faEdit, faL } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from "react-router-dom";
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSideBar';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { ExportToCsv } from "export-to-csv";
import { Box, Button } from "@mui/material";

import RKVYListing from '../NewAdminPanel/Userlist/RKVYList';
import DASDListing from '../NewAdminPanel/Userlist/DASDList';
import CDBListing from '../NewAdminPanel/Userlist/CDBList';
import RADListing from '../NewAdminPanel/Userlist/RADList';
import PDMCListing from '../NewAdminPanel/Userlist/PDMCList';
import AgroListing from '../NewAdminPanel/Userlist/AgroList';
import CropHealthListing from '../NewAdminPanel/Userlist/CropHealthList';
import MIDHListing from '../NewAdminPanel/Userlist/MIDHList';
import CIHListing from '../NewAdminPanel/Userlist/MIDHList';
import NHFListing from '../NewAdminPanel/Userlist/NHFList';
import NMEOOP from '../NewAdminPanel/Userlist/NMEOOP';
import NBHM from '../NewAdminPanel/Userlist/NBHM';
import PKVYList from './Userlist/PKVYList';
import NBMList from './Userlist/NBMList';
//import DCCD from './Userlist/DCCD';

let farmerSearchMemoryCache = {
    schemeCode: "",
    filters: null,
    data: null,
};

const Farmer = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [optionState, setOptionState] = useState([]);
    const [stateValue, setStateValue] = useState([]);
    const [optionDistrict, setOptionDistrict] = useState([]);
    const [districtValue, setDistrictValue] = useState('');
    const [farmerData, setfarmerData] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [hasNextPage, setHasNextPage] = useState(true);
    const [LoaderFarmer, setLoaderFarmer] = useState(false);
    const [isFetchingState, setIsFetchingState] = useState(true);
    const [selectedDataSetDistrict, setselectedDataSetDistrict] = useState('');
    const [optionSubDistrict, setOptionSubDistrict] = useState([]);
    const [subdistrictValue, setsubDistrictValue] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [villageValue, setvillageValue] = useState([]);
    const [selectedDataSetSubDistrict, setselectedDataSetSubDistrict] = useState('');
    const [selectedDataSetVillage, setselectedDataSetVillage] = useState('');
    const [surveyValue, setSurveyValue] = useState("");
    const [surveyorNameValue, setSurveyorNameValue] = useState("");
    const [mobilenoValue, setMobilenoValue] = useState("");
    const [landareaValue, setlandareaValue] = useState("");
    const [totalareaValue, settotalareaValue] = useState("");
    const [surveynoValue, setSurveynoValue] = useState("");
    const [editCode, setEditCode] = useState({});
    const fetchedVillageKeys = useRef(new Set());
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [cropSeason, setCropSeason] = useState([]);
    const [cropSeasonValue, setCropSeasonValue] = useState(''); 
    const [cropGroup, setCropGroup] = useState([]);
    const [cropGroupValue, setCropGroupValue] = useState('');
    const [cropName, setCropName] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const [cropNameValue, setCropNameValue] = useState('');
    const [header,setHeader] = useState("");
    const [selectedFinYear, setSelectedFinYear] = useState("All");
    const [finYears, setFinYears] = useState(() => {
         const now = new Date();
         const currentYear = now.getFullYear();
         const currentMonth = now.getMonth();
         const fyStartYear = currentMonth < 3 ? currentYear - 1 : currentYear;
         const years = ["All"];
     
         // Add last 5 financial years based on April-April cycle
         for (let i = 0; i < 5; i++) {
           const startYear = fyStartYear - i;
           const endYear = startYear + 1;
           years.push(`${startYear}-${endYear}`);
         }
     
         return years;
       });
     
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const normalizedPath = (location?.pathname || "").toLowerCase();
    const navHeader = location && location.state && location.state.header
        ? String(location.state.header)
        : "";
    const label =
      schemeCode === "15"
        ? normalizedPath === "/newadminpanel/seeddemonstration"
          ? "Seed Demonstration"
          : "Project"
        : "Farmer";
    // Add new state for tracking if dropdowns should be disabled
    const [isStateDisabled, setIsStateDisabled] = useState(false);
    const [isDistrictDisabled, setIsDistrictDisabled] = useState(false);
    const [isSubDistrictDisabled, setIsSubDistrictDisabled] = useState(false);
    // const validSchemeCodesForSeedDemonstrationFarmers = ["20", "9", "8", "5"];
    const validSchemeCodesForSeedDemonstrationFarmers = [];

    const strFinYearForApi = selectedFinYear === "All" ? "" : selectedFinYear;
    const getSearchFilters = () => ({
        schemeCode,
        stateValue,
        districtValue,
        subdistrictValue,
        villageValue,
        selectedDataSetDistrict,
        selectedDataSetSubDistrict,
        selectedDataSetVillage,
        selectedFinYear,
    });
    const autoSelectDoneRef = useRef(false);
    const persistSearchState = (data, filters = getSearchFilters()) => {
        const list = Array.isArray(data) ? data : [];
        farmerSearchMemoryCache = {
            schemeCode,
            filters,
            data: list,
        };

        try {
            sessionStorage.setItem("searchFilters", JSON.stringify(filters));
            sessionStorage.removeItem("searchResults");
        } catch (_) {
            // Heavy result rows stay in memory; sessionStorage keeps only small filters.
        }
    };
 // Function to fetch sub-districts for auto-selected district
    const fetchSubDistricts = async(stateCode, districtCode) => {
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/subdistrict`,
                requestOptions
            );

            const result = await response.text();
            const localFormDataSubDistrict = JSON.parse(result).dataContent;
            let myArraySubDistrict = [];
            localFormDataSubDistrict.map((item, key) => {
                myArraySubDistrict.push({ 
                    label: item.subDistrictName, 
                    value: item.subDistrictCode, 
                    districtCode: item.districtCode 
                });
            });
            
            setOptionSubDistrict(myArraySubDistrict);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching sub-districts:", error);
        }
    };

    // Function to fetch villages for auto-selected sub-district
    const fetchVillages = async (stateCode, districtCode, subDistrictCode) => {
        // Check if we already tried to fetch villages for this combination
        const villageKey = `${stateCode}-${districtCode}-${subDistrictCode}`;
        if (fetchedVillageKeys.current.has(villageKey)) {
            return; // Don't fetch again
        }
        
        // Mark this combination as attempted
        fetchedVillageKeys.current.add(villageKey);
        
        try {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                stateCode: stateCode.toString(),
                districtCode: districtCode.toString(),
                subDistrictCode: subDistrictCode.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            const response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            );

            const result = await response.text();
            const parsedResult = JSON.parse(result);
            const localFormDataVillage = parsedResult.dataContent;

            let myArrayVillage = [];
            if (localFormDataVillage && localFormDataVillage.length > 0) {
                localFormDataVillage.map((item, key) => {
                    myArrayVillage.push({ 
                        label: item.villageName, 
                        value: item.villageCode, 
                        subDistrictCode: item.subDistrictCode 
                    });
                });
            }

            setOptionVillage(myArrayVillage);
            setIsFetching(false);
        } catch (error) {
            console.error("Error fetching villages:", error);
            setOptionVillage([]);
            setIsFetching(false);
        }
    };

    // New useEffect to handle user-level restrictions after states are loaded
    useEffect(() => {
        if (optionState.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            // Try both possible session storage keys for state and district codes
             const stateCode = sessionStorage.getItem("stateNameModel");
             const districtCode = getStoredDistrictRef();
             const subDistrictCode = sessionStorage.getItem("subDistrictNameModel"); 
          
            // First, select the values based on user permissions
            if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // State level user - auto-select state
                // Try to find the matching option and use its exact value format
                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // District level user - auto-select state
                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
                // Sub-district level user - auto-select state

                const matchingOption = optionState.find(option => option.value == stateCode || option.value === Number(stateCode) || option.value === String(stateCode));
                if (matchingOption) {
                    setStateValue([matchingOption.value]);
                } else {
                    setStateValue([stateCode]);
                }
                setIsFetchingState(false); // Trigger district loading
            } else {
                // Regular user or admin - no auto-selection
                setStateValue([]);
            }
        }
    }, [optionState]); // Trigger when state options are loaded

    // Separate useEffect to freeze dropdowns after values are set
    useEffect(() => {
    const userType = sessionStorage.getItem("userTypeCodeModel");
    const stateCode = sessionStorage.getItem("stateNameModel");
    const districtCode = getStoredDistrictRef();

    if (userType === "2" && stateCode && stateCode !== "null" && stateCode !== "0") {
        setIsStateDisabled(true);
        setIsDistrictDisabled(false);
        setIsSubDistrictDisabled(false);
    } else if (userType === "3" && stateCode && stateCode !== "null" && stateCode !== "0") {
        setIsStateDisabled(true);
        // District admin: always freeze district when district code exists
        if (districtCode && districtCode !== "null" && districtCode !== "0") {
            setIsDistrictDisabled(true);
        } else {
            setIsDistrictDisabled(false);
        }
    } else if (userType === "4" && stateCode && stateCode !== "null" && stateCode !== "0") {
        setIsStateDisabled(true);
        if (districtCode && districtCode !== "null" && districtCode !== "0") {
            setIsDistrictDisabled(true);
        } else {
            setIsDistrictDisabled(false);
        }
    } else {
        setIsStateDisabled(false);
        setIsDistrictDisabled(false);
        setIsSubDistrictDisabled(false);
    }
}, [stateValue, districtValue]); // ✅ districtValue bhi dependency mein add karo

    // New useEffect to handle district auto-selection after districts are loaded
    useEffect(() => {
        if (optionDistrict.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            const districtCode = getStoredDistrictRef();
            // First select the district value
            if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0") {
                const matchingDistrictOption = findMatchingOption(optionDistrict, districtCode);
                if (matchingDistrictOption) {
                    setDistrictValue(matchingDistrictOption.value);
                    setselectedDataSetDistrict(`${matchingDistrictOption.stateid}|${matchingDistrictOption.value}`);
                    
                    // Trigger sub-district loading by calling the API directly
                    const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                    if (stateCode) {
                        fetchSubDistricts(stateCode, matchingDistrictOption.value);
                    }
                } else {
                    setDistrictValue(districtCode);
                }
            }
        }
    }, [optionDistrict]); // Trigger when district options are loaded

  

    // Separate useEffect to freeze district dropdown after district value is set
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const districtCode = getStoredDistrictRef();
        
        // Freeze district dropdown for district and sub-district admins
        if ((userType === "3" || userType === "4") && districtCode && districtCode !== "null" && districtCode !== "0" && districtValue.length > 0) {
            setIsDistrictDisabled(true);
        }
    }, [districtValue]); // Trigger when districtValue changes
 const getStoredDistrictRef = () => {
        const districtCode = sessionStorage.getItem("districtCodeModel");
        const districtName = sessionStorage.getItem("districtNameModel");
        if (districtCode && districtCode !== "null" && districtCode !== "0") {
            return districtCode;
            
        }
        if (districtName && districtName !== "null" && districtName !== "0") {
            return districtName;
        }
        return "";
    };

    const findMatchingOption = (options, ref) => {
        if (!ref || ref === "null" || ref === "0") return null;
        const refStr = String(ref).trim();
        return options.find((option) =>
            String(option.value) === refStr ||
            option.value == ref ||
            String(option.label).trim().toLowerCase() === refStr.toLowerCase()
        ) || null;
    };

    const findDistrictSelectValue = (options, selectedDistrict) => {
        if (!selectedDistrict || selectedDistrict === "null" || selectedDistrict === "0") return null;
        return findMatchingOption(options, selectedDistrict);
    };
    const isOptionSelected = (selectedValues, option) => {
        if (!Array.isArray(selectedValues) || selectedValues.length === 0) return false;
        return selectedValues.some((selected) =>
            String(selected) === String(option.value) ||
            String(selected).trim().toLowerCase() === String(option.label).trim().toLowerCase()
        );
    };
   
    useEffect(() => {
        getStates();
        
    }, []);

    // New useEffect to handle sub-district auto-selection after sub-districts are loaded
    useEffect(() => {
        if (optionSubDistrict.length > 0) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
            const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
            
            // First select the sub-district value
            if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0") {
                // Try to find matching option with different data types
                const matchingOption = optionSubDistrict.find(option => 
                    option.value == subDistrictCode || 
                    option.value === Number(subDistrictCode) || 
                    option.value === String(subDistrictCode)
                );
                
                if (matchingOption) {
                    setsubDistrictValue([matchingOption.value]);
                    setselectedDataSetSubDistrict(`${matchingOption.districtCode}|${matchingOption.value}`);
                    
                    // Trigger village loading for sub-district admin
                    const stateCode = stateValue[0] || sessionStorage.getItem("stateNameModel");
                    const districtCode = districtValue[0] || getStoredDistrictRef() || matchingOption.districtCode;
                    
                    console.log("Sub-district auto-selection - Village loading attempt:", {
                        stateCode,
                        districtCode,
                        subDistrictCode: matchingOption.value,
                        stateValue,
                        districtValue,
                        matchingOption
                    });
                    
                    if (stateCode && districtCode) {
                        // Add a small delay to ensure all state updates are processed
                        setTimeout(() => {
                            fetchVillages(stateCode, districtCode, matchingOption.value);
                        }, 100);
                    } else {
                        console.log("Village loading skipped - missing state or district code");
                    }
                } else {
                    setsubDistrictValue([subDistrictCode]);
                }
            }
        }
    }, [optionSubDistrict, stateValue, districtValue]); // Trigger when sub-district options are loaded and state/district values are set

    // Separate useEffect to freeze sub-district dropdown after sub-district value is set
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        
        // Freeze sub-district dropdown for sub-district admins
        if (userType === "4" && subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0" && subdistrictValue.length > 0) {
            setIsSubDistrictDisabled(true);
        }
    }, [subdistrictValue]); // Trigger when subdistrictValue changes

    // Additional useEffect to ensure village loading for sub-district admin when all values are ready
    useEffect(() => {
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        
                // If sub-district admin and all required values are available, ensure villages are loaded
        if (userType === "4" && 
            subDistrictCode && subDistrictCode !== "null" && subDistrictCode !== "0" &&
            stateValue.length > 0 && 
            districtValue.length > 0 && 
            subdistrictValue.length > 0 &&
            optionVillage.length === 0) { // Only if villages aren't already loaded
            
            fetchVillages(stateValue[0], districtValue[0], subdistrictValue[0]);
        }
    }, [stateValue, districtValue, subdistrictValue, optionVillage]); // Trigger when any of these change

    useEffect(() => {
        let storedHeader = "";
        try {
            storedHeader = sessionStorage.getItem("farmerHeader") || "";
        } catch (_) {
            storedHeader = "";
        }

        const nextHeader = navHeader || storedHeader || label;
        setHeader(nextHeader);

        try {
            if (navHeader) {
                sessionStorage.setItem("farmerHeader", navHeader);
            } else if (!storedHeader) {
                sessionStorage.removeItem("farmerHeader");
            }
        } catch (_) {
            // ignore storage issues
        }

        const cachedSearch =
            farmerSearchMemoryCache.schemeCode === schemeCode &&
            Array.isArray(farmerSearchMemoryCache.data) &&
            farmerSearchMemoryCache.filters;

        if (cachedSearch) {
            const filters = farmerSearchMemoryCache.filters;
            setStateValue(filters.stateValue || []);
            setDistrictValue(filters.districtValue || "");
            setsubDistrictValue(filters.subdistrictValue || []);
            setvillageValue(filters.villageValue || []);
            setselectedDataSetDistrict(filters.selectedDataSetDistrict || "");
            setselectedDataSetSubDistrict(filters.selectedDataSetSubDistrict || "");
            setselectedDataSetVillage(filters.selectedDataSetVillage || "");
            setSelectedFinYear(filters.selectedFinYear || "All");
            setfarmerData(farmerSearchMemoryCache.data);
            setIsFetching(false);
            setLoaderFarmer(false);
            return;
        }

        sessionStorage.removeItem("searchResults");
        sessionStorage.removeItem("searchFilters");

        setfarmerData([]);
        setPage(1);
        setPerPage(10);
        setHasNextPage(true);
        setLoaderFarmer(false);
        setIsFetching(false);
        setIsFetchingState(false);

        setOptionDistrict([]);
        setOptionSubDistrict([]);
        setOptionVillage([]);

        setStateValue([]);
        setIsStateDisabled(false);
        setDistrictValue('');
        setIsDistrictDisabled(false);
        setsubDistrictValue([]);
        setvillageValue([]);
        setselectedDataSetDistrict('');
        setselectedDataSetSubDistrict('');
        setselectedDataSetVillage('');

        setSurveyValue("");
        setSurveyorNameValue("");
        setMobilenoValue("");
        setlandareaValue("");
        settotalareaValue("");
        setSurveynoValue("");
        setStartDate("");
        setEndDate("");
        setCropSeasonValue('');
        setCropGroupValue('');
        setCropNameValue('');
        setErrorMessage("");
        setEditCode({});

        const userType = sessionStorage.getItem("userTypeCodeModel");
        const stateCode = sessionStorage.getItem("stateNameModel");
        const districtCode = sessionStorage.getItem("districtNameModel");

        



        if (userType === "2" && stateCode && stateCode !== "null") {
            setIsStateDisabled(true);
            setStateValue([stateCode]);
        } else if (userType === "3" && stateCode && stateCode !== "null") {
            setIsStateDisabled(true);
            setStateValue([stateCode]);
            

            if (districtCode && districtCode !== "null") {
                setIsDistrictDisabled(true);
                setDistrictValue(districtCode);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [normalizedPath, navHeader, label]);

    // Call getStates when component mounts
    useEffect(() => {
        getStates();
        getCropSeasonName();
        getCropGroupName();
        getCropName();
    }, []);

    useEffect(() => {
        // Check user type and set disabled states
        const userType = sessionStorage.getItem("userTypeCodeModel");
        const stateCode = sessionStorage.getItem("stateNameModel");
        const districtCode = sessionStorage.getItem("districtNameModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        
        if (userType === "2" && stateCode !== "null") {
            // State level user - auto-select state and disable
            console.log("Setting up state admin");
            //alert("State Admin User");
           // alert(stateCode);
            setStateValue([stateCode]);
            setIsStateDisabled(true);
        } else if (userType === "3" && stateCode && stateCode !== "null") {
            // District level user - auto-select state and disable
           // console.log("Setting up district admin");
            setStateValue([stateCode]);
            setIsStateDisabled(true);
            if (districtCode !== "null") {
                setDistrictValue(districtCode);
                setIsDistrictDisabled(true);
            }
        } else {
            // Regular user - enable state selection
            setStateValue([]);
            setIsStateDisabled(false);
        }
        
        // For scheme 9, fetch data immediately
        if (schemeCode === "9") {
            setIsFetchingState(true);
        }
    }, []);

    useEffect(() => {
        const savedResults = sessionStorage.getItem("searchResults");
        const savedFilters = sessionStorage.getItem("searchFilters");
        const userType = sessionStorage.getItem("userTypeCodeModel");

        // Only restore saved filters for regular users, not for admin users
        if (savedResults && savedFilters && userType !== "2" && userType !== "3") {
            setfarmerData(JSON.parse(savedResults));
            const filters = JSON.parse(savedFilters);
            setStateValue(filters.stateValue);
            setDistrictValue(filters.districtValue);
            setsubDistrictValue(filters.subDistrictValue);
            setvillageValue(filters.villageValue);
            setselectedDataSetDistrict(filters.selectedDataSetDistrict);
            setselectedDataSetSubDistrict(filters.selectedDataSetSubDistrict);
            setselectedDataSetVillage(filters.selectedDataSetVillage);
        }
    }, []);

    useEffect(() => {
        if (sessionStorage.getItem("schemeCodeModel") !== "8") return;
        if (!stateValue || stateValue.length === 0) return;
        fetchDataFilterWise();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- run when FY changes only
    }, [selectedFinYear]);

    useEffect(() => {
        if (isFetchingState == false) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
        if (userType === "3" || userType === "2") return; // Guard
            handleState();
            setIsFetchingState(true);
        }
    }, [stateValue]);
useEffect(() => {
   if (optionDistrict.length > 0 && stateValue?.length > 0) {
      // existing logic
   }
}, [optionDistrict, stateValue]);
    useEffect(() => {
        if (districtValue) {
            const userType = sessionStorage.getItem("userTypeCodeModel");
        if (userType === "3") return; // ✅ District admin ke liye skip
        
            handleChangeDistrict({
                value: districtValue,
                stateid: stateValue[0]
            });
        }
    }, [districtValue]);

    function getStates() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            redirect: "follow",
        };
        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/states`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataState = JSON.parse(result).dataContent;
                let myArray = [];
                localFormDataState.map((item) => {
                    myArray.push({
                        value: item.stateCode,
                        label: item.stateName,
                    });
                });
                setOptionState(myArray);

                // Check if user is state admin (userTypeCodeModel = 2) or district admin (userTypeCodeModel = 3)
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const stateCode = sessionStorage.getItem("stateNameModel");
                const districtCode = sessionStorage.getItem("districtNameModel");
                
                
                
                if ((userType === "2" || userType === "3") && stateCode && stateCode !== "null") {
                    // Find the matching state in our options
                    const matchingState = myArray.find(state => 
                        String(state.value) === String(stateCode)
                    );
                    
                    if (matchingState && !autoSelectDoneRef.current) {
                    autoSelectDoneRef.current = true; // ✅ Sirf ek baar chale
                    
                    setStateValue([matchingState.value]);
                    setIsStateDisabled(true);
                    fetchDistrictsAndAutoSelect(matchingState.value, userType, districtCode);
                }
            }
        })
                        
                        // Auto-load districts for the selected state
                    //     handleState(matchingState.value);
                        
                    //     // If district admin, also select district
                    //     if (userType === "3" && districtCode && districtCode !== "null") {
                    //         setDistrictValue(districtCode);
                            
                    //         setIsDistrictDisabled(true);
                    //     }
                    // } else {
                    //   //  console.error("Could not find matching state for code:", stateCode);
                    // }
               // }
           // })
            .catch((error) => console.error("Error fetching states:", error));

        
    }
    function fetchDistrictsAndAutoSelect(stateCode, userType, districtCode) {

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
         var raw = JSON.stringify({ stateCode: stateCode.toString() });
         var requestOptions = { method: "POST", headers: myHeaders, redirect: "follow", body: raw };
         fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/district`,
            requestOptions
            )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataDistrict = JSON.parse(result).dataContent;
                let myArrayDistrict = [];
                localFormDataDistrict.map((item) => {
                    myArrayDistrict.push({
                        value: item.districtCode,
                        label: item.districtName,
                        stateid: item.stateCode
                    });
                });
                setOptionDistrict(myArrayDistrict);
                if (userType === "3" && districtCode && districtCode !== "null") {
                 const districtOption = myArrayDistrict.find(d => 
                    String(d.value) === String(districtCode)
                );
                if (districtOption) {
                     setDistrictValue(districtOption.value); // ✅ Object nahi, sirf value
                    setselectedDataSetDistrict(`${districtOption.stateid}|${districtOption.value}`);
                    setIsDistrictDisabled(true);
                    console.log("District auto-selected and disabled");
                    
                    // Sub-districts fetch karo (village nahi)
                    fetchSubDistricts(stateCode, districtOption.value);
                    console.log("districtOption", districtOption.value, districtOption.label);
                }
                }
                 setIsFetching(false);
            })
             .catch((error) => console.error("Error:", error));
    }

    function getCropSeasonName() {
        const fetchCropGroup = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/cropcategory`
            );
            setCropGroup(result.data.dataContent);
        };
        fetchCropGroup();
    }


    function getCropGroupName() {
        const fetchCropSeason = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/seasons`
            );
            setCropSeason(result.data.dataContent);
        };
        fetchCropSeason();
    }

    function getCropName() {
        const fetchCropName = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/seasons`
            );
            setCropName(result.data.dataContent);
        };
        fetchCropName();
    }

    function handleState(stateCodeParam = null) {
        const currentStateValue = stateCodeParam ? [stateCodeParam] : stateValue;
        console.log("handleState called with stateValue:", currentStateValue, "param:", stateCodeParam);
        setOptionDistrict([]);
        setDistrictValue('');
        setsubDistrictValue([]);
        setvillageValue([]);

        if (currentStateValue && currentStateValue.length > 0) {
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            let stateValueData = "";

            currentStateValue.map((item) => {
                stateValueData = stateValueData + item + ","
            })

            stateValueData = stateValueData.slice(0, -1);
           // console.log("Fetching districts for state:", stateValueData);
            
            var raw = JSON.stringify({
                stateCode: stateValueData.toString()
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };

            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/district`,
                requestOptions
            )

            .then((response) => response.text())
            .then((result) => {
                let localFormDataDistrict = JSON.parse(result).dataContent;
              //  console.log("Districts loaded:", localFormDataDistrict);

                let myArrayDistrict = [];
                localFormDataDistrict.map((item, key) => {
                    myArrayDistrict.push({ label: item.districtName, value: item.districtCode, stateid: item.stateCode })
                })

                setOptionDistrict(myArrayDistrict);
               // console.log("District options set:", myArrayDistrict);
                
                // Auto-select district for district admin
                const userType = sessionStorage.getItem("userTypeCodeModel");
                const districtCode = sessionStorage.getItem("districtNameModel");
                
                if (userType === "3" && districtCode && districtCode !== "null") {
                    //console.log("Auto-selecting district for district admin:", districtCode);
                    const districtOption = myArrayDistrict.find(district => 
                        String(district.value) === String(districtCode) || 
                        parseInt(district.value) === parseInt(districtCode)
                    );
                    //console.log("Found district option:", districtOption);
                    
                    if (districtOption) {
                        setDistrictValue(districtCode);
                        setselectedDataSetDistrict(`${districtOption.stateid}|${districtCode}`);
                        setIsDistrictDisabled(true);
                        console.log("District auto-selected and disabled");
                        
                        // Auto-load sub-districts for district admin
                        setTimeout(() => {
                            handleChangeDistrict(districtOption);
                        }, 100);
                    }
                }
                
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
        }
    }

    let handleChangeDistrict = (selectedOption, isAutoSelect = false) => {
    const userType = sessionStorage.getItem("userTypeCodeModel");
    
    // ✅ Sirf manual change block karo, auto-select allow karo
    if (userType === "3" && !isAutoSelect) {
        return;
    }
    
    setOptionSubDistrict([]);
    setsubDistrictValue('');
    setvillageValue('');
    
    if (selectedOption) {
        setDistrictValue(selectedOption.value);
        setselectedDataSetDistrict(`${selectedOption.stateid}|${selectedOption.value}`);
        
        let stateValueData = stateValue[0];
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            
            var raw = JSON.stringify({
                stateCode: stateValueData.toString(),
                districtCode: selectedOption.value.toString()
            });
            
           // console.log("Fetching sub-districts with params:", raw);
            
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };
            
            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/subdistrict`,
                requestOptions
            )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataSubDistrict = JSON.parse(result).dataContent;
               // console.log("Sub-district response:", localFormDataSubDistrict);
                
                let myArraySubDistrict = [];
                localFormDataSubDistrict.map((item, key) => {
                    myArraySubDistrict.push({ 
                        label: item.subDistrictName, 
                        value: item.subDistrictCode, 
                        districtCode: item.districtCode 
                    });
                });
                
                setOptionSubDistrict(myArraySubDistrict);
                setIsFetching(false);
            })
            .catch((error) => {
                console.error("Error fetching sub-districts:", error);
                setIsFetching(false);
            });
        } else {
            setDistrictValue('');
            setselectedDataSetDistrict('');
            setOptionSubDistrict([]);
        }
    };

    let handleChangeSubDistrict = (selectedOption) => {
        setvillageValue('');
        setOptionVillage([]);
        
        if (selectedOption) {
            setsubDistrictValue(selectedOption.value);
            setselectedDataSetSubDistrict(`${selectedOption.districtCode}|${selectedOption.value}`);
            
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            
            let stateValueData = stateValue[0];
            let districtValueData = districtValue;
            
            var raw = JSON.stringify({
                stateCode: stateValueData.toString(),
                districtCode: districtValueData.toString(),
                subDistrictCode: selectedOption.value.toString()
            });
            
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };
            
            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            )
            .then((response) => response.text())
            .then((result) => {
                let localFormDataVillage = JSON.parse(result).dataContent;
                
                let myArrayVillage = [];
                localFormDataVillage.map((item, key) => {
                    myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                })
                
                setOptionVillage(myArrayVillage)
                setIsFetching(false);
            })
            .catch((error) => console.log("error", error));
        } else {
            setsubDistrictValue('');
            setselectedDataSetSubDistrict('');
        }
    };

    const fetchData = async () => {
        let result;
        let result1;

        if (sessionStorage.getItem("schemeCodeModel") === "5") {
            setLoaderFarmer(true);

            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",

            })

            if (result.data.dataContent.success === true) {
                const data = await result.data.dataContent;
                sessionStorage.setItem("searchResults", JSON.stringify(data));
                sessionStorage.setItem("searchFilters", JSON.stringify({
                    stateValue,
                    districtValue,
                   
                    villageValue,
                    selectedDataSetDistrict,
                    selectedDataSetSubDistrict,
                    selectedDataSetVillage
                }));
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
            }
            else {
                alert('No Data Found.');
                setLoaderFarmer(false);
            }

        } else if (sessionStorage.getItem("schemeCodeModel") === "7") {

            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 4,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),

            })

            console.log("result", result);

            result1 = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getProjectDetailsList`, {
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),

            })

            console.log("result1", result1);
            let DataContent = [...result.data.dataContent, ...result1.data.dataContent]
            console.log("dataContent", DataContent)
            setfarmerData(DataContent);
            setIsFetching(false);

        } else if (sessionStorage.getItem("schemeCodeModel") === "3") {
            result1 = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getProjectDetailsList`, {
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("schemeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),

            })

            setfarmerData(result1.data.dataContent);
            setIsFetching(false);

        } else if (sessionStorage.getItem("schemeCodeModel") === "6") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListNew`, {
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),

            })
            
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListData`, {
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000

            })
            
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        } else if (sessionStorage.getItem("schemeCodeModel") === "8") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`, {
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "str_FinYear": strFinYearForApi,
            })
            //  setfarmerData(result.data.dataContent);
            //setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        } else if (sessionStorage.getItem("schemeCodeModel") === "10") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CDB/CDB/GetCDBFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : 0,
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "str_FinYear": strFinYearForApi,
                //  "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "11") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetDasdFarmerDetailsAsync`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                // "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : 0,
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "str_FinYear": strFinYearForApi,
                //  "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            // setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            setLoaderFarmer(true);
            if (sessionStorage.getItem("userTypeCodeModel") === "5") {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {
                   
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": "0",
                    "PageNumber": page


                })
            }
            else {


                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "PageNumber": page


                })
            }
            //  setfarmerData(result.data.dataContent);
            //  setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "13") {
            setLoaderFarmer(true);
            if (sessionStorage.getItem("userTypeCodeModel") === "5") {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CropInsurance/GetSurveyDetails`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": "0",
                    "SchemeCode": "13"


                })
            }
            else {


                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/CropInsurance/GetSurveyDetails`, {

                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "SchemeCode": "13"


                })
            }
            //   setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else if (sessionStorage.getItem("schemeCodeModel") === "1") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page
            })
            //setfarmerData(result.data.dataContent);
            // setIsFetching(false);

            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);

        }
        else {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? 0 : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);


        }



        // const result = await axios(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/users`);

    };

    let handleChange = (selectedOption) => {
        // Check user type - if state admin (type 2) or district admin (type 3), don't allow changes
        const userType = sessionStorage.getItem("userTypeCodeModel");
        if (userType === "2" || userType === "3") {
            return;
        }
        
        setIsFetchingState(false);
        setStateValue(selectedOption ? [selectedOption.value] : []);
        if (!selectedOption) {
            setDistrictValue('');
            setOptionDistrict([]);
            setsubDistrictValue('');
            setOptionSubDistrict([]);
            setvillageValue('');
            setOptionVillage([]);
            setselectedDataSetDistrict('');
            setselectedDataSetSubDistrict('');
            setselectedDataSetVillage('');
            // Clear farmer data when state is cleared
            setfarmerData([]);
            setErrorMessage('');
        }
    };

    let handleChangeVillage = (selectedOption) => {
        if (selectedOption) {
            setvillageValue(selectedOption.value);
            setselectedDataSetVillage(`${selectedOption.subDistrictCode}|${selectedOption.value}`);
        } else {
            setvillageValue('');
            setselectedDataSetVillage('');
        }
    };

    function formatData(value) {
        if (sessionStorage.getItem("schemeCodeModel") === "8" || sessionStorage.getItem("schemeCodeModel") === "10" || sessionStorage.getItem("schemeCodeModel") === "11") {
            return value.componentName
        }
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Honey Processing Unit"
        } else if (value.orgTypeCode === 2) {
            return "Honey Testing Unit"
        } else if (value.orgTypeCode === 3) {
            return "Honey CHC"
        } else if (value.orgTypeCode === 4) {
            return "Beeflora Plantation"
        }
    }

    function formatData2(value) {
        console.log("value name", value.orgTypeCode);
        if (value.orgTypeCode === 1) {
            return "Nursery"
        } else if (value.orgTypeCode === 2) {
            return "Tissue Culture Unit"
        } else {
            return "Tissue Culture Unit"
        }
    }

    const fetchDataExporttoCsv = async () => {
        setLoaderFarmer(true);
        let stateValueData = "";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";

        // Concatenate all state values with a comma
        stateValue.forEach((item) => {
            stateValueData += item + ",";
        });
        // Remove trailing comma
        stateValueData = stateValueData.slice(0, -1);

        // If stateValueData is null or empty, set stateCode to "0"
        const stateCode = stateValueData === "" || stateValueData === null ? "0" : stateValueData;

        if (selectedDataSetDistrict !== "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict !== "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage !== "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
        console.log("stateValueData", stateCode);
        console.log("districtValueData", districtValueData);
        console.log("subdistrictValueData", subdistrictValueData);
        console.log("villageValueData", villageValueData);

        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(
                `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsExport`,
                {
                    
                    SchemeCode: "12", 
                    stateCode: stateCode, // Use our conditional stateCode here
                    districtCode: districtValueData,
                    subDistrictCode: subdistrictValueData,
                    villageCode: villageValueData,
                    fromdate: startDate,
                    todate: endDate,
                    PageNumber: 1,
                }
            );
            if (result.data.success === true) {
                const data = await result.data.dataContent;
                setIsFetching(false);
                setLoaderFarmer(false);
                return data;
            } else {
                alert("something went wrong.");
                setLoaderFarmer(false);
            }
        }
    };


    const handleExportDataNew = async () => {
        let allowed;
        const farmerDataExportNew = await fetchDataExporttoCsv();
        allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        //console.log("Test Data", farmerDataExportNew[0]);
        var result = farmerDataExportNew.map(function (obj) {
            var newObj = {};

            allowed.forEach(function (key) {

                newObj[key] = obj[key];


            });
            return newObj;
        });
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);

    }
    const handleExportDataNewu = async () => {
    try {
        // Fetch data
        const farmerDataExportNew = await fetchDataExporttoCsv();
       //  console.log("aaaaaaaaaaaaaaaaaaaaaaa",farmerDataExportNew.data.dataContent)
        if(farmerDataExportNew.data.dataContent.length !=0){
        // Check if data is valid
        if (!farmerDataExportNew || !Array.isArray(farmerDataExportNew)) {
            console.error("Error: fetchDataExporttoCsv() returned invalid data", farmerDataExportNew);
            alert("Failed to export: No data available.");
            return;
        }

        // Allowed keys for export
       // const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName', 'subDistrictName', 'villageName', 'currentyear', 'minorCropCategoryName', 'showingDate', 'polygonArea', 'cropCategoryName', 'cropName', 'cropConditionName', 'cropStageName', 'cropingTypeName', 'polygonShape', 'surveyorName', 'createdOnByUC', 'ratioofmajorcrop', 'minorCropName', 'surveyorLat', 'surveyorLong', 'userMobile', 'imgPath', 'company_name', 'minorCropCategoryName']
        const  allowed = ['surveyCode', 'schemeName', 'stateName', 'districtName']
       

        // Transform data
        const result = farmerDataExportNew.map(obj => {
            let newObj = {};
            allowed.forEach(key => {
                newObj[key] = obj[key] ?? ""; // Ensure empty string for missing values
            });
            return newObj;
        });

        console.log("Export Data:", result);
        // Add export logic here
        const csvOptions = {
            fieldSeparator: ",",
            quoteStrings: '"',
            decimalSeparator: ".",
            showLabels: true,
            useBom: true,
            useKeysAsHeaders: false,
            headers: allowed,
        };

        const csvExporter = new ExportToCsv(csvOptions);
        csvExporter.generateCsv(result);
       } 
    } catch (error) {
        console.error("Error in handleExportDataNew:", error);
        alert("An error occurred while exporting data.");
    }
};


   const handleExportData = () => {
  const schemeCode = sessionStorage.getItem("schemeCodeModel");
  //alert(schemeCode);

  // Flattening function
  const flattenObject = (obj, parentKey = '', result = {}) => {
    for (let key in obj) {
      if (!obj.hasOwnProperty(key)) continue;
      const fullKey = parentKey ? `${parentKey}.${key}` : key;

      if (Array.isArray(obj[key]) && obj[key].length > 0 && typeof obj[key][0] === 'object') {
        // Flatten first item of array
        flattenObject(obj[key][0], '', result);
      } else if (typeof obj[key] === 'object' && obj[key] !== null) {
        flattenObject(obj[key], fullKey, result);
      } else {
        result[key] = obj[key];
      }
    }
    return result;
  };

  let exportData = farmerData?.map(item => flattenObject(item));

  // Collect all unique keys from the flattened objects
  const allKeys = new Set();
  exportData.forEach(row => {
    Object.keys(row).forEach(key => allKeys.add(key));
  });

  const headers = Array.from(allKeys);

  // Rebuild data using all keys
  const result = exportData.map(item => {
    const row = {};
    headers.forEach(key => {
      row[key] = item[key] ?? '';
    });
    return row;
  });

  const csvOptions = {
    fieldSeparator: ",",
    quoteStrings: '"',
    decimalSeparator: ".",
    showLabels: true,
    useBom: true,
    useKeysAsHeaders: false,
    headers: headers,
  };

  const csvExporter = new ExportToCsv(csvOptions);
  csvExporter.generateCsv(result);
};




    function ValidateUpdateUser() {

        let valid = false;

        if (mobilenoValue === "") {
            alert("Enter Mobile no")

            valid = false;
            return;
        } else {
            valid = true;

        }
        if (landareaValue === "") {
            alert("Enter land area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (totalareaValue === "") {
            alert("Enter total area")

            valid = false;
            return;
        } else {
            valid = true;

        }

        if (surveynoValue === "") {
            alert("Enter Survey No")

            valid = false;
            return;
        } else {
            valid = true;

        }


        if (valid === true) {
            UpdateNewUser()
        }



    }

    function UpdateNewUser() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({

            "createdByUC": sessionStorage.getItem("userCodeModel"),
            "schemeCode": sessionStorage.getItem("schemeCodeModel"),
            "farmerCode": editCode,
            "mobileNo": mobilenoValue,
            "surveyNo": surveynoValue,
            "landArea": landareaValue,
            "totalArea": totalareaValue
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/Nature/FarmerDetails/UpdateFarmerDetails`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => {
               // alert(JSON.parse(result).message);
                if (JSON.parse(result).success == true) {
                    //   setFlag(true);
                    // navigate("/newadminpanel/userlist");
                }
            })
            .catch((error) => console.log("error", error));

    }

    const handlePrevPage = async () => {
        setLoaderFarmer(true);
        let result;
        setPage(page - 1);
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1
            })
        }
       else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListNew`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page - 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page - 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        setIsFetching(false);
        setHasNextPage(true)
    };

    const handleNextPage = async () => {
        setLoaderFarmer(true);

        setPage(page + 1);
        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "1") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsOnly`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "9") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListNew`, {

                "SchemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 1,
                "SurveyUserCode": "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? "0" : sessionStorage.getItem("stateNameModel"),
                "districtCode": sessionStorage.getItem("districtNameModel") === "null" ? "0" : sessionStorage.getItem("districtNameModel"),
                "subDistrictCode": "0",
                "PageNumber": page + 1,
                "PageSize": 1000
            })
        }
        else if (sessionStorage.getItem("schemeCodeModel") === "12") {
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {

                "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                "PageNumber": page + 1
            })
        }
        const data = await result.data.dataContent;
        setLoaderFarmer(false);
        setfarmerData(data);
        if (result.data.message === "Data Not Found") {
            setHasNextPage(false)
        }
        setIsFetching(false);
    };


    function handleSurveyNumber(value) {
        const valueFinal = value.replace(/\D/g, "");
        setSurveyValue(valueFinal)
    }

    function handleSurveyorName(value) {
        //alert(value);
       // const valueFinal = value.replace(/\D/g, "");
        setSurveyorNameValue(value)
        console.log("value==========",value)
        
    }



    const fetchDataFilterWise = async () => {
        setLoaderFarmer(true);
        setfarmerData([]);
        let stateValueData = (stateValue && stateValue.length > 0) ? stateValue[0] : "0";
        let districtValueData = "0";
        let subdistrictValueData = "0";
        let villageValueData = "0";

        if (selectedDataSetDistrict != "") {
            const districtParts = selectedDataSetDistrict.split("|");
            districtValueData = districtParts[1];
        }
        if (selectedDataSetSubDistrict != "") {
            const SubdistrictParts = selectedDataSetSubDistrict.split("|");
            subdistrictValueData = SubdistrictParts[1];
        }
        if (selectedDataSetVillage != "") {
            const VillageDataParts = selectedDataSetVillage.split("|");
            villageValueData = VillageDataParts[1];
        }
        console.log("stateValueData", stateValueData);
        console.log("districtValueData", districtValueData);
        console.log("subdistrictValueData", subdistrictValueData);
        console.log("villageValueData", villageValueData);
        console.log("surveyorName", surveyorNameValue);
        console.log("cropSeasonValue", cropSeasonValue);
        console.log("cropGroupValue", cropGroupValue);
        console.log("cropNameValue", cropNameValue);
        console.log("startDate", startDate);
        console.log("endDate", endDate);

        let result;
        if (sessionStorage.getItem("schemeCodeModel") === "12") {

            if (surveyValue != '') {
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetails`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "CropSurveyCode": surveyValue
                });
            }
            else {
                
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/GT/GetSurveyDetailsOnly`, {
                    "CreatedBy": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "UperLevelUserCode": sessionStorage.getItem("userCodeModel") === "null" ? 0 : sessionStorage.getItem("userCodeModel"),
                    "schemeCode": "12",
                    "stateCode": stateValueData,
                    "districtCode": districtValueData,
                    "subDistrictCode": subdistrictValueData,
                    "villageCode": villageValueData,
                    "surveyorName": surveyorNameValue,
                    "cropSeasonValue": cropSeasonValue,
                    "cropGroupValue": cropGroupValue,
                    "cropNameValue": cropNameValue,
                    "fromdate": startDate,
                    "todate": endDate,
                    "PageNumber": 1 
                });
            }


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                sessionStorage.setItem("searchResults", JSON.stringify(data));
                sessionStorage.setItem("searchFilters", JSON.stringify({
                    stateValue,
                    districtValue,
                   
                    villageValue,
                    selectedDataSetDistrict,
                    selectedDataSetSubDistrict,
                    selectedDataSetVillage
                }));
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "14") {

         
                result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/NMEO_OP/getNMEOFarmerDetailsList`, {
                   
                    "schemeCode": "14",
                    "orgTypeCode": "1",
                    "lngA_FarmerCode": "0",
                    "int_Block_Code": "0",
                    "lng_SurveyUserCode": "0",
                    "str_MobileNo": "",
                    "int_State_Code": stateValueData,
                    "int_District_Code": districtValueData,
                    "int_SubDistrict_Code": subdistrictValueData,
                    "int_VillageCode": villageValueData,
         });
            


            if (result.data.success === true) {

                const data = await result.data.dataContent;
                persistSearchState(data);
                setfarmerData(data);
                setIsFetching(false);
           setLoaderFarmer(false);
                setErrorMessage(""); // Clear any validation error messages when data is successfully loaded
                // return data;
            }
            else {

                alert('No Data Found.');
                setLoaderFarmer(false);

            }
        }

        if (sessionStorage.getItem("schemeCodeModel") === "9") {

            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/Nature/FarmerDetails/getFarmerDetailsListNew`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                 "stateCode": stateValueData,
                    "districtCode": districtValueData,
                    "subDistrictCode": subdistrictValueData,
                    "villageCode": villageValueData,
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            if (result.data.success === true) {
                const data = await result.data.dataContent;
                sessionStorage.setItem("searchResults", JSON.stringify(data));
                sessionStorage.setItem("searchFilters", JSON.stringify({
                    stateValue,
                    districtValue,
                    subdistrictValue,
                    villageValue,
                    selectedDataSetDistrict,
                    selectedDataSetSubDistrict,
                    selectedDataSetVillage
                }));
                setfarmerData(data);
                setIsFetching(false);
                setLoaderFarmer(false);
                setErrorMessage(""); // Clear any validation error messages when data is successfully loaded
            } else {
                alert('No Data Found.');
                setLoaderFarmer(false);
            }
           } 

         if (sessionStorage.getItem("schemeCodeModel") === "15") {
         //   alert("sessionStorage.getItem('schemeCodeModel')", sessionStorage.getItem("schemeCodeModel"));
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/RKVY/RKVYProject/RKVYProjectExtList`, {
                // "surveyUserCode": sessionStorage.getItem("userCodeModel"),
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": sessionStorage.getItem("schemeCodeModel") === "3" ? 0 : 1,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": sessionStorage.getItem("stateNameModel") === "null" ? 0 : sessionStorage.getItem("stateNameModel"),
                "districtCode": districtValueData,
                "subDistrictCode": sessionStorage.getItem("subDistrictNameModel") === "null" ? 0 : sessionStorage.getItem("subDistrictNameModel"),
                "PageNumber": page,
                "PageSize": 1000
                // "villageCode" : sessionStorage.getItem("villageModel") === "null" ? 0 : sessionStorage.getItem("villageModel")

            })
            
            // setfarmerData(result.data.dataContent);
            //  setIsFetching(false);
            const data = await result.data.dataContent;
            setfarmerData(data);
            setIsFetching(false);
            setLoaderFarmer(false);
           }

        if (sessionStorage.getItem("schemeCodeModel") === "8") {
            setLoaderFarmer(true);
            result = await axios.post(`${process.env.NODE_ENV === 'development' ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`, {
                "schemeCode": sessionStorage.getItem("schemeCodeModel"),
                "orgTypeCode": 0,
                "SurveyUserCode": sessionStorage.getItem("userTypeCodeModel") === "5" ? sessionStorage.getItem("userCodeModel") : "0",
                "stateCode": stateValueData,
                "districtCode": districtValueData,
                "subDistrictCode": subdistrictValueData,
                "villageCode": villageValueData,
                "str_FinYear": strFinYearForApi,
            });
            const data = result.data?.dataContent;
            if (result.data?.success === true || Array.isArray(data)) {
                const list = Array.isArray(data) ? data : [];
                persistSearchState(list);
                setfarmerData(list);
                setIsFetching(false);
                setLoaderFarmer(false);
                setErrorMessage("");
            } else {
                alert('No Data Found.');
                setfarmerData([]);
                setLoaderFarmer(false);
            }
        }

    };

    function ClearSearch(){
        setStateValue([]);
        setOptionDistrict([]);
        setDistrictValue('');
        setfarmerData([]);
        setselectedDataSetDistrict('');
        setOptionSubDistrict([]);
        setsubDistrictValue('');
        setOptionVillage([]);
        setvillageValue('');
        setselectedDataSetSubDistrict('');
        setselectedDataSetVillage('');
        setSurveyValue('');
        setSurveyorNameValue('');
        setStartDate("");
        setEndDate("");
        setErrorMessage(""); // Clear any error messages when clearing the form
        farmerSearchMemoryCache = {
            schemeCode: "",
            filters: null,
            data: null,
        };
        sessionStorage.removeItem("searchResults");
        sessionStorage.removeItem("searchFilters");
    }

const ValidateAddUser = () => {
    //alert(sessionStorage.getItem("schemeCodeModel"))
   // alert()
   
    if (!stateValue || stateValue.length === 0) {
         setErrorMessage("Please select a State.");
         return false;
    }
   
    
    
    if (sessionStorage.getItem("schemeCodeModel") === "12") {
    if (!startDate) {
         setErrorMessage('Start Date is required.');
       
        return false;
    }

     if (!endDate) {
        setErrorMessage('End Date is required.');
        return false;
    } else if (startDate && endDate < startDate) {
        setErrorMessage('End Date cannot be earlier than Start Date.');
        return false;
        
    }

    setErrorMessage("") 
    }
    // If all validations pass, fetch the filtered data
    fetchDataFilterWise();

};


    function navigateData(userData) {
       // alert(userData);
        navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: userData } })
    }



    const columns = useMemo(() => {
        const schemeCodeModel = sessionStorage.getItem("schemeCodeModel");

        return [
            {
                header: 'S.No',
                Cell: cell => Number(cell.row.id) + 1,
                size: 20,
            },
             // View Details Button Logic
            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessor: '',
                header: 'View Details',
                size: 120,
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/survey/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            } : (schemeCodeModel === "9") ? {
                accessor: '',
                size: 120,
                header: 'Action',
                Cell: cell => (<>
                    <i className="btn" type="button" onClick={() => navigateData(cell.row.original)}>pSU <FontAwesomeIcon icon={faEye} /></i>
                    <i className="btn text-danger" type="button" data-bs-toggle="modal" data-bs-target="#staticBackdrop_user" onClick={() => setEditCode(cell.row.original.farmerCode)}> <FontAwesomeIcon icon={faEdit} /></i>
                </>)
            } : {
                accessor: '',
                header: 'View Details',
                size: 120,
                Cell: cell => (
                    <button className="btn" type="button" onClick={() => navigate("/newadminpanel/farmer/detailview", { state: { farmerCode: cell.row.original } })}>
                        <i><FontAwesomeIcon icon={faEye} /></i>
                    </button>
                )
            },
            {
                accessorKey: 'stateName',
                header: 'State',
                size: 120,
            },
            {
                accessorKey: 'districtName',
                header: 'District',
                size: 120,
            },


            
           (schemeCodeModel === "7" || schemeCodeModel === "3" || schemeCodeModel === "10") ? 
            {
                accessorKey: 'beneficiaryName',
                size: 120,
                header: 'Beneficiary Name',
            } : (schemeCodeModel === "12" || schemeCodeModel === "13") ? 
            {
                accessorKey: 'villageName',
                size: 120,
                header: 'Village Name',
            } : (schemeCodeModel !== "15") ? 
            {
                accessorKey: 'farmerName',
                size: 120,
                header: 'Farmer Name',
            } : null,


            // Scheme Data Type or Crop Group/Crop Condition
           (
              schemeCodeModel === "11"
                ? {
                    accessorKey: 'schemeDataTypeName',
                    size: 120,
                    header: 'Scheme Data Type',
                  }
                : (schemeCodeModel === "12" || schemeCodeModel === "13")
                ? {
                    accessorKey: 'cropCategoryName',
                    size: 120,
                    header: 'Crop Group Name',
                  }
                : null
            ),


            (schemeCodeModel === "10") ? 
                {
                    accessorKey: 'mobile_No',
                    size: 120,
                    header: 'Mobile No.',
                } : (schemeCodeModel === "12" || schemeCodeModel === "13") ? 
                {
                    accessorKey: 'surveyorName',
                    size: 120,
                    header: 'Surveyor Name',
                } : (schemeCodeModel !== "15") ? 
                {
                    accessorKey: 'mobileNo',
                    size: 120,
                    header: 'Mobile No.',
                } : null,

            // Component/Additional Data Handling
            (schemeCodeModel === "3") ? {
                header: 'Component',
                size: 120,
                accessorFn: originalRow => formatData2(originalRow), // Use accessorFn for dynamic data
                id: 'orgTypeCode',
            } : (schemeCodeModel === "7" || schemeCodeModel === "8" || schemeCodeModel === "10" || schemeCodeModel === "11") ? {
                header: 'Component',
                size: 120,
                accessorFn: originalRow => formatData(originalRow),
                id: 'orgTypeCode',
            } : null,  // Add null for cases where this doesn't apply

            // Crop Condition & Crop Name Logic
            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessorKey: 'cropConditionName',
                size: 120,
                header: 'Crop Condition',
            } : null,

            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessorKey: 'cropName',
                size: 120,
                header: 'Crop Name',
            } : null,

            // Mobile for Surveyors (12/13)
            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessorKey: 'userMobile',
                size: 120,
                header: 'Mobile',
            } : null,
            
            (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessorKey: 'company_name',
                size: 120,
                header: 'Company Name',
            } : null,
           (schemeCodeModel === "12" || schemeCodeModel === "13") ? {
                accessorKey: 'createdOnByUC',
                size: 120,
                header: 'Survey Date',
                Cell: ({ cell }) => {
                    const value = cell.getValue();
                    if (!value) return "";

                    const date = new Date(value);
                    return date.toLocaleDateString('en-GB');
                }
            } : null,

            (schemeCodeModel === "13") ? {
                accessorKey: 'surveyType',
                size: 120,
                header: 'Survey Type',
            } : null,

                 ...(schemeCodeModel === "15" ? [
        { accessorKey: 'userName', header: 'User Name' },
        { accessorKey: 'sectorName', header: 'Sector Name' },
        { accessorKey: 'projectStatus', header: 'Project Status' }
    ] : []),


       
        ].filter(Boolean); // Use .filter(Boolean) to remove null entries
    }, []);

    return (
        <>
            <AdminHeaderNew />
            <AdminSideBarNew  setHeader={setHeader} />

            <main id="main" className="main">
                <div className="pagetitle page_title_box d-flex align-items-start align-items-md-center justify-content-between flex-wrap gap-3 w-100">
                    <div className="pagetitle-titles flex-grow-1 min-w-0">
                        {validSchemeCodesForSeedDemonstrationFarmers.includes(
                            schemeCode
                        ) && <nav>
                            <h1>{label} List - {header}</h1>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">{label} List</li>
                                <li className="breadcrumb-item active">{label}</li>
                            </ol>
                        </nav>}

                        {sessionStorage.getItem("schemeCodeModel") === "12" || sessionStorage.getItem("schemeCodeModel") === "13" ? (
                            <nav>
                                <h1>Survey List</h1>
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">Survey</li>
                                    <li className="breadcrumb-item active">Survey Detail</li>
                                </ol>
                            </nav>
                        ) : (!validSchemeCodesForSeedDemonstrationFarmers.includes(
                            schemeCode
                        ) && <nav>
                            <h1>{label} List</h1>
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">{label} List</li>
                                <li className="breadcrumb-item active">{label}</li>
                            </ol>
                        </nav>)}
                    </div>
                    {sessionStorage.getItem("schemeCodeModel") == "88" && (
                    <div className="form-group text-white">
              <label htmlFor="finYear" className="form-label text-white">
                            Financial Year
                        </label>
                        <select
                            id="finYear"
                            className="form-select finacildd_labelbox"
                            value={selectedFinYear}
                            onChange={(e) => {
                                const v = e.target.value;
                                setSelectedFinYear(v);
                                try {
                                    sessionStorage.setItem("finYear", v === "All" ? "" : v);
                                } catch (_) { /* ignore */ }
                            }}
                            style={{
                                border: "1px solid white",
                                color: "white",
                                height: "36px",
                              }}
                        >
                            {finYears.map((year) => (
                                <option key={year} value={year} style={{ color: "black" }}>
                                    {year}
                                </option>
                            ))}
                        </select>
                    </div>
                    )}
               </div>
                <div style={{marginTop: "10px"}}></div>
                  {sessionStorage.getItem("schemeCodeModel") === "15" &&
                    <RKVYListing />
                  }{sessionStorage.getItem("schemeCodeModel") === "11" &&       
                    <DASDListing />
                  }{sessionStorage.getItem("schemeCodeModel") === "10" &&       
                    <CDBListing />
                  }
                  {sessionStorage.getItem("schemeCodeModel") === "2" &&       
                    <RADListing />
                  }{sessionStorage.getItem("schemeCodeModel") === "1" &&       
                    <PDMCListing />
                  }{sessionStorage.getItem("schemeCodeModel") === "3" &&       
                    <AgroListing />
                  }{sessionStorage.getItem("schemeCodeModel") === "13" &&       
                    <CropHealthListing />
                  }{sessionStorage.getItem("schemeCodeModel") === "8" &&       
                    <MIDHListing />
                  }{sessionStorage.getItem("schemeCodeModel") === "6" &&       
                    <NHFListing />
                  }
                  {sessionStorage.getItem("schemeCodeModel") === "5" &&       
                    <NMEOOP />
                  }{sessionStorage.getItem("schemeCodeModel") === "48" &&       
                    <NMEOOP />
                  }{sessionStorage.getItem("schemeCodeModel") === "7" &&       
                    <NBHM />
                  }{sessionStorage.getItem("schemeCodeModel") === "20" &&       
                    <PDMCListing />
                  }
                  {sessionStorage.getItem("schemeCodeModel") === "17" &&       
                    <AgroListing />
                  }
                  {sessionStorage.getItem("schemeCodeModel") === "46" &&       
                    <CIHListing />
                  }
                  {sessionStorage.getItem("schemeCodeModel") === "22" && <PKVYList />}

                  {sessionStorage.getItem("schemeCodeModel") === "21" && <NBMList />}
                  
                <section className="section">
                    {sessionStorage.getItem("schemeCodeModel") === "12" ? (<>
                       
                        <div className="row surveydetailsBg">
                           
                            <div className="col-md-3">
                                <label htmlFor="State" className="form-label">
                                    State
                                </label><label style={{ color: "red" }}>*</label>
                                <Select
                                    options={optionState}
                                    value={stateValue && stateValue.length > 0 ? optionState.find(option => option.value === stateValue[0]) : null}
                                    onChange={handleChange}
                                    isClearable={!isStateDisabled}
                                    isSearchable={true}
                                    isDisabled={isStateDisabled}
                                    isMulti={false}
                                    hideSelectedOptions={false}
                                    placeholder="Select State"
                                    classNamePrefix="select"
                                    components={{
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>
                                                {children}
                                            </components.Option>
                                        )
                                    }}
                                />
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="District" className="form-label">
                                    District
                                </label><label style={{ color: "red" }}></label>
                                <Select
    options={optionDistrict}
    // ✅ String comparison se type mismatch fix hoga
    value={optionDistrict.find(
        option => String(option.value) === String(districtValue)
    ) || null}
    onChange={handleChangeDistrict}
    isClearable={!isDistrictDisabled}
    isDisabled={isDistrictDisabled}
    placeholder="Select District"

/>
                                {/* <Select
                                    options={optionDistrict}
                                    value={optionDistrict.find(option => option.value === districtValue)}
                                    onChange={handleChangeDistrict}
                                    isClearable={!isDistrictDisabled}
                                    isSearchable={true}
                                    isDisabled={isDistrictDisabled}
                                    placeholder="Select District"
                                    classNamePrefix="select"
                                    components={{
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>
                                                {children}
                                            </components.Option>
                                        )
                                    }}
                                /> */}
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="SubDistrict" className="form-label">
                                    Sub District
                                </label><label style={{ color: "red" }}></label>
                                <Select
                                    options={optionSubDistrict}
                                    value={optionSubDistrict.find(option => option.value === subdistrictValue)}
                                    onChange={handleChangeSubDistrict}
                                    isClearable={true}
                                    isSearchable={true}
                                    isMulti={false}
                                    hideSelectedOptions={false}
                                    placeholder="Select Sub District"
                                    classNamePrefix="select"
                                    components={{
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>
                                                {children}
                                            </components.Option>
                                        )
                                    }}
                                />
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="Village" className="form-label">
                                    Village123
                                </label><label style={{ color: "red" }}></label>
                                <Select
                                    options={optionVillage}
                                    value={optionVillage.find(option => option.value === villageValue)}
                                    onChange={handleChangeVillage}
                                    isClearable={true}
                                    isSearchable={true}
                                    isMulti={false}
                                    hideSelectedOptions={false}
                                    placeholder="Select Village"
                                    classNamePrefix="select"
                                    components={{
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>
                                                {children}
                                            </components.Option>
                                        )
                                    }}
                                />
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="mobileNo" className="form-label">
                                    Survey Code
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="surveynumber"
                                    required
                                    placeholder="Survey No."
                                    onChange={(e) => handleSurveyNumber(e.target.value)}
                                    value={surveyValue}
                                    maxLength="10"


                                />
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="mobileNo" className="form-label">
                                    Surveyor Name
                                </label><label style={{ color: "red" }}></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="surveyname"
                                    placeholder="Surveyor Name"
                                    onChange={(e) => handleSurveyorName(e.target.value)}
                                    value={surveyorNameValue}
                                  
                                />
                            </div>

                              <div className="col-md-3">
                                 <label htmlFor="mobileNo" className="form-label">
                                    Crop Seasons
                                </label>
                               
                                <select className="form-control" onChange={(e) => setCropSeasonValue(e.target.value)} value={cropSeasonValue}>
                                    <option defaultValue value="NA">Choose Crop Season</option>
                                    {cropSeason
                                    ? cropSeason.map((item, id) => {
                                        return (
                                            <option key={id} value={item.seasonCode}>
                                                {" "}
                                                {item.seasonName}
                                            </option>
                                        );
                                    })
                                    : ""}
                                </select>
                                
                              </div>
                              <div className="col-md-3">
                                 <label htmlFor="mobileNo" className="form-label">
                                    Crop Group
                                </label>
                               
                                <select className="form-control" onChange={(e) => setCropGroupValue(e.target.value)} value={cropGroupValue}>
                                    <option defaultValue value="NA">Choose Crop Group</option>
                                    {cropGroup
                                    ? cropGroup.map((item, id) => {
                                        return (
                                            <option key={id} value={item.cropCategoryCode}>
                                                {" "}
                                                {item.cropCategoryName}
                                            </option>
                                        );
                                    })
                                    : ""}
                                </select>
                                
                              </div>

                              <div className="col-md-3">
                                 <label htmlFor="mobileNo" className="form-label">
                                    Crop Name
                                </label>
                               
                                <select className="form-control" onChange={(e) => setCropNameValue(e.target.value)} value={cropNameValue}>
                                    <option defaultValue value="NA">Choose Crop Name</option>
                                    {cropName
                                    ? cropName.map((item, id) => {
                                        return (
                                            <option key={id} value={item.cropCategoryCode}>
                                                {" "}
                                                {item.cropCategoryName}
                                            </option>
                                        );
                                    })
                                    : ""}
                                </select>
                                
                              </div>


                            <div className="col-md-2">
                                            <label htmlFor="startdate" className="form-label">Start Date<label style={{ color: "red" }}>*</label></label>
                                            <input type="date" className="form-control"  value={startDate}  id="startDate" max={endDate} onChange={e => setStartDate(e.target.value)} />
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="enddate" className="form-label">End Date<label style={{ color: "red" }}>*</label></label>
                                            <input type="date" className="form-control" value={endDate}  id="endDate" min={startDate} onChange={e => setEndDate(e.target.value)} />
                                        </div>
                          <br /> <br />                     
                          <div className="col-md-12 d-flex justify-content-md-center mt-3">

                            <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAddUser} >Submit</button>
                            <button type="button" className="btn btn-success me-md-2"  onClick={ClearSearch}>Clear</button>
                           
                        </div>
                       


                        </div>
                        
                         {errorMessage && (
                                <div className="alert alert-danger" role="alert">
                                 {errorMessage}
                                </div>
                            )}
                        
                       
                    </>) : (<></>)}

                    {(sessionStorage.getItem("schemeCodeModel") !== "2" && sessionStorage.getItem("schemeCodeModel") !== "15" && sessionStorage.getItem("schemeCodeModel") !== "14" && sessionStorage.getItem("schemeCodeModel") !== "1" && sessionStorage.getItem("schemeCodeModel") !== "5" && sessionStorage.getItem("schemeCodeModel") !== "48" && sessionStorage.getItem("schemeCodeModel") !== "9" && sessionStorage.getItem("schemeCodeModel") !== "15") && (
                        farmerData.length > 0 ? (
                    <div className="row justify-content-lg-center">

                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={farmerData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                    state={{ isLoading: isFetching ? true : false }}
                                    renderTopToolbarCustomActions={({ table }) => (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "1rem",
                                                p: "0.5rem",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {sessionStorage.getItem("schemeCodeModel") === "12" ?
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportDataNew}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>

                                                :
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportData}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>
                                            }

                                        </Box>
                                    )}
                                />
                                {sessionStorage.getItem("schemeCodeModel") === "12" || sessionStorage.getItem("schemeCodeModel") === "1"|| sessionStorage.getItem("schemeCodeModel") === "9" ?
                                    (<div className='d-flex justify-content-center m-3'>
                                        <button onClick={handlePrevPage} className="btn btn-success btn-sm" disabled={page === 1}>Prev</button>
                                        <span style={{ margin: '8px 10px' }}>Page {page}</span>
                                        <button onClick={handleNextPage} className="btn btn-success btn-sm" disabled={!hasNextPage}>Next</button>

                                    </div>)
                                    :
                                    (
                                        <></>
                                    )
                                }

                            </div>

                        </div>


                    </div>
                        ) : (
                            // Empty state - no message needed
                            <></>
                        )
                    )}
                </section>
                
                   <section className="section">

                    {sessionStorage.getItem("schemeCodeModel") === "14" || sessionStorage.getItem("schemeCodeModel") === "9"  ? (<>
                       
                        <div className="row surveydetailsBg">
                            <div className="col-md-3">
                                <label htmlFor="State" className="form-label">
                                    State
                                </label>
                                <Select
                                    options={optionState}
                                    value={stateValue && stateValue.length > 0 ? optionState.find(option => option.value === stateValue[0]) : null}
                                    onChange={handleChange}
                                    isClearable={!isStateDisabled}
                                    isSearchable={true}
                                    isDisabled={isStateDisabled}
                                    isMulti={false}
                                    hideSelectedOptions={false}
                                    placeholder="Select State"
                                    classNamePrefix="select"
                                    components={{
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>
                                                {children}
                                            </components.Option>
                                        )
                                    }}
                                />
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="District" className="form-label">
                                    District
                                </label><label style={{ color: "red" }}></label>
                                <Select
                                    options={optionDistrict}
                                    value={optionDistrict.find(option => option.value === districtValue)}
                                    onChange={handleChangeDistrict}
                                    isClearable={!isDistrictDisabled}
                                    isSearchable={true}
                                    isDisabled={isDistrictDisabled}
                                    isMulti={false}
                                    hideSelectedOptions={false}
                                    placeholder="Select District"
                                    classNamePrefix="select"
                                    components={{
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>
                                                {children}
                                            </components.Option>
                                        )
                                    }}
                                />
                            </div>
                            <div className="col-md-3">
                                <label htmlFor="SubDistrict" className="form-label">
                                    Sub District
                                </label><label style={{ color: "red" }}></label>
                                <Select
                                    options={optionSubDistrict}
                                    value={optionSubDistrict.find(option => option.value === subdistrictValue)}
                                    onChange={handleChangeSubDistrict}
                                    isClearable={true}
                                    isSearchable={true}
                                    isMulti={false}
                                    hideSelectedOptions={false}
                                    placeholder="Select Sub District"
                                    classNamePrefix="select"
                                    components={{
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>
                                                {children}
                                            </components.Option>
                                        )
                                    }}
                                />
                            </div>

                            <div className="col-md-3">
                                <label htmlFor="Village" className="form-label">
                                    Village
                                </label><label style={{ color: "red" }}></label>
                                <Select
                                    options={optionVillage}
                                    value={optionVillage.find(option => option.value === villageValue)}
                                    onChange={handleChangeVillage}
                                    isClearable={true}
                                    isSearchable={true}
                                    isMulti={false}
                                    hideSelectedOptions={false}
                                    placeholder="Select Village"
                                    classNamePrefix="select"
                                    components={{
                                        Option: ({ children, ...props }) => (
                                            <components.Option {...props}>
                                                {children}
                                            </components.Option>
                                        )
                                    }}
                                />
                            </div>
                            
                          <br /> <br />                     
                          <div className="col-md-12 d-flex justify-content-md-center mt-3">

                            <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={ValidateAddUser} >Submit </button>
                            <button type="button" className="btn btn-success me-md-2"  onClick={ClearSearch}>Clear</button>
                        </div>

                        </div>
                        
                        {errorMessage && (
                                <div className="alert alert-danger" role="alert">
                                 {errorMessage}
                                </div>
                            )} 
                       
                    </>) : (<></>)}

                    {sessionStorage.getItem("schemeCodeModel") === "14" && (
                        farmerData.length > 0 ? (
                    <div className="row justify-content-lg-center">

                        <div className="col-lg-12 ">

                            <div className="card">

                                <MaterialReactTable
                                    columns={columns}
                                    data={farmerData}
                                    enableColumnOrdering
                                    enablePagination={true}
                                    state={{ isLoading: isFetching ? true : false }}
                                    renderTopToolbarCustomActions={({ table }) => (
                                        <Box
                                            sx={{
                                                display: "flex",
                                                gap: "1rem",
                                                p: "0.5rem",
                                                flexWrap: "wrap",
                                            }}
                                        >
                                            {sessionStorage.getItem("schemeCodeModel") === "12" ?
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportDataNew}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>

                                                :
                                                <Button
                                                    color="primary"
                                                    //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                                                    onClick={handleExportData}
                                                    startIcon={<FileDownloadIcon />}
                                                    variant="contained"
                                                >
                                                    Export in CSV
                                                </Button>
                                            }

                                        </Box>
                                    )}
                                />
                                {sessionStorage.getItem("schemeCodeModel") === "12" || sessionStorage.getItem("schemeCodeModel") === "1"|| sessionStorage.getItem("schemeCodeModel") === "9" ?
                                    (<div className='d-flex justify-content-center m-3'>
                                        <button onClick={handlePrevPage} className="btn btn-success btn-sm" disabled={page === 1}>Prev</button>
                                        <span style={{ margin: '8px 10px' }}>Page {page}</span>
                                        <button onClick={handleNextPage} className="btn btn-success btn-sm" disabled={!hasNextPage}>Next</button>

                                    </div>)
                                    :
                                    (
                                        <></>
                                    )
                                }

                            </div>

                        </div>


                    </div>
                        ) : (
                            // Empty state - no message needed
                            <></>
                        )
                    )}
                </section>

                {LoaderFarmer === false ? "" : <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>}
            </main>

            <div className="modal fade" id="staticBackdrop_user" data-bs-backdrop="staticBackdrop_user" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="deleteLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="deleteLabel">Edit Data</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
                        </div>
                        <div className="modal-body">

                            <div className='row'>
                                <div className='col-md-4'>
                                    <label className="form-label">Mobile No.</label><label style={{ color: "red" }}>*</label>
                                    <input placeholder='Mobile Number' type='text' className='form-control' maxLength={10} onChange={(e) => setMobilenoValue(e.target.value)} value={mobilenoValue} />

                                </div>
                                <div className='col-md-4'>
                                    <label className="form-label">Land Area in ha.</label><label style={{ color: "red" }}>*</label>
                                    <input placeholder='Land Area in ha.' type='text' className='form-control' maxLength={3} onChange={(e) => setlandareaValue(e.target.value)} value={landareaValue} />

                                </div>
                                <div className='col-md-4'>
                                    <label className="form-label">Total Area in OF</label><label style={{ color: "red" }}>*</label>
                                    <input placeholder='Total Area under OF' type='text' className='form-control' maxLength={3} onChange={(e) => settotalareaValue(e.target.value)} value={totalareaValue} />

                                </div>

                            </div>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <label className="form-label">Survey No.</label><label style={{ color: "red" }}>*</label>
                                    <input placeholder='Survey No.' type='text' className='form-control' maxLength={5} onChange={(e) => setSurveynoValue(e.target.value)} value={surveynoValue} />

                                </div>
                            </div>


                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-bs-dismiss="modal" onClick={ValidateUpdateUser}>Update</button>
                            <button type="button" className="btn border" data-bs-dismiss="modal">No</button>

                        </div>
                    </div>
                </div>
            </div>
            <AdminFooterNew />
        </>
    )
}

export default Farmer;